import { MingaPermission, MingaRoleType } from 'libs/domain';
import { DisplayNameFormat, mingaSettingTypes } from 'libs/util';

import { UserRole } from './UserRole';

/**
 * @deprecated no longer used
 */
export class SchoolManagerRole extends UserRole {
  readonly roleType = MingaRoleType.SCHOOL_MANAGER;
  readonly name = 'School Manager';
  readonly displayNameFormat = DisplayNameFormat.F_LAST;
  readonly iconUrl = 'assets/roles/school-manager.svg';
  readonly iconColor = '#FFBD2F';
  readonly capabilitiesDescription = `School Managers will be allowed to share posts, pictures, videos, events, and polls`;
  readonly feedPermittable = true;
  readonly galleryPermittable = true;
  readonly groupFeedPermittable = true;
  readonly programManagePermittable = false;
  readonly videoUploadPermittable = true;
  readonly groupCreatePermittable = true;
  readonly admin = true;
  readonly commentPermittable = true;
  readonly requiredFeatures = [mingaSettingTypes.FEATURE_DISTRICT_ENABLED];
  readonly sendToMailChimp = true;

  readonly permissions = [
    MingaPermission.CONTENT_DELETE_OTHERS,
    MingaPermission.ACCOUNT_DISPLAYNAME_CHANGE,
    MingaPermission.ACCOUNT_PROFILE_CHANGE,
    MingaPermission.ASSET_UPLOAD,
    MingaPermission.CONTENT_COMMENT_CREATE,
    MingaPermission.CONTENT_COMMENTS_VIEW,
    MingaPermission.CONTENT_EVENT_CREATE,
    MingaPermission.CONTENT_GROUP_CREATE,
    MingaPermission.CONTENT_GROUP_VIEWALL,
    MingaPermission.CONTENT_GROUP_ENABLED,
    MingaPermission.CONTENT_HTML_INCLUDE,
    MingaPermission.CONTENT_LIKES_LIKE,
    MingaPermission.CONTENT_MODERATION_OVERRIDE,
    MingaPermission.CONTENT_POST_CREATE,
    MingaPermission.CONTENT_POST_SET_TITLE,
    MingaPermission.CONTENT_PUBLISH_DATES_SET,
    MingaPermission.CONTENT_REPORT_CREATE,
    MingaPermission.CONTENT_REPORTS_MANAGE,
    MingaPermission.CONTENT_VIDEO_CREATE,
    MingaPermission.GROUP_CONTENT_EVENTS_CREATE,
    MingaPermission.GROUP_CONTENT_POLL_CREATE,
    MingaPermission.GROUP_CONTENT_POST_CREATE,
    MingaPermission.GROUP_CONTENT_VIDEO_CREATE,
    MingaPermission.MINGA_CONTENT_PIN,
    MingaPermission.CONTENT_POLL_ANSWER,
    MingaPermission.CONTENT_ANY_GET_DELETED,
    MingaPermission.CONTENT_CREATED_MINGA_DESIGNER_CONTENT,
    MingaPermission.GROUP_ALLOW_PARENT_GROUP,
    MingaPermission.EMAIL_CONTENT_AS_GROUP_OWNER,
    MingaPermission.GALLERY_DELETE_OTHERS_PHOTO,
    MingaPermission.CONTENT_MANAGE_COMMENT_SETTINGS,
    MingaPermission.MINGA_PEOPLE_MANAGE,
    MingaPermission.MINGA_POLLS_MANAGE,
    MingaPermission.CONTENT_CHALLENGE_CREATE,
    MingaPermission.GROUP_CONTENT_CHALLENGE_CREATE,
    MingaPermission.CHALLENGE_COMPLETE,
    MingaPermission.CHECKIN_TYPE_MANAGE,
    MingaPermission.CHECKIN_MANAGE,
    MingaPermission.CHECKIN_VIEW_REPORTS,
    MingaPermission.POINTS_VIEW_REPORTS,
    MingaPermission.FLEX_TIME_MANAGE,
    MingaPermission.SCHEDULED_REPORTS_MANAGE,
    MingaPermission.SCHEDULED_REPORTS_DOWNLOAD_PAST_REPORT,
    MingaPermission.STUDENT_SCHEDULE_VIEW,
    MingaPermission.BELL_SCHEDULE_MANAGE,
    MingaPermission.VIEW_PROFILE,
  ];
  readonly overridablePermissions = [MingaPermission.CONTENT_SMS_MESSAGE_CREATE];
}
